module.exports = __webpack_public_path__ + "static/media/photo252.61284615.jpg";